// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","FooterIcons":"Footer_FooterIcons__2VNKa","FooterText":"Footer_FooterText__5A1PA"};